import { nftIdentity } from './nftIdentity.js';

// This is a display count of distinct tokens, not a transaction authorization or
// an ERC1155 quantity. Only a successfully refreshed backend snapshot is input.
export function countCollectionTokens(items, {chain, contract, wallet}) {
  if (!Array.isArray(items) || !/^0x[\da-f]{40}$/i.test(contract || '') || !/^0x[\da-f]{40}$/i.test(wallet || '')) {
    throw new Error('Collection balance is unavailable');
  }
  const identities = new Set();
  for (const item of items) {
    const identity = nftIdentity(item);
    if (!identity || identity[0] !== chain || identity[1] !== contract.toLowerCase()) continue;
    const owner = item.owner_of ?? item.ownerOf;
    if (owner && owner.toLowerCase() !== wallet.toLowerCase()) throw new Error('Wallet changed while loading collection');
    if (item.isStaked) continue;
    identities.add(JSON.stringify(identity));
  }
  return identities.size;
}
